import { useMutation, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import qs from "qs";
import { ApiConstant } from "const";
import { ApiUtils, HumpUtils, SystemUtils } from "utils";

export default function useChannelDelete() {
  const { t: getLabel } = useTranslation();
  const queryClient = useQueryClient();

  const deleteChannelMutation = useMutation({
    mutationFn: async ({ groupId }) => {
      const payload = qs.stringify(HumpUtils.decamelizeKeys({ all: 1, groupId }));
      const response = await ApiUtils.createApiWithToken(false).post(ApiConstant.DELETE_CHANNEL, payload);
      return HumpUtils.camelizeKeys(response.data);
    },
    onMutate: () => {
      SystemUtils.openCircleLoading();
    },
    onSettled: () => {
      SystemUtils.openCircleLoading(false);
    },
    onSuccess: async (response, { onSuccess }) => {
      if (response?.status === ApiConstant.STT_OK) {
        SystemUtils.appendNotification(getLabel("TXT_DISSOLVE_CHANNEL_SUCCESS"), "success");
        await queryClient.invalidateQueries(ApiConstant.REACT_QUERY_KEYS.getChannelList);
        onSuccess?.();
      } else {
        SystemUtils.appendNotification(getLabel("TXT_DISSOLVE_CHANNEL_FAIL"), "error");
      }
    },
    onError: () => {
      SystemUtils.appendNotification(getLabel("TXT_TIMEOUT"), "error");
    },
  });

  const deleteChannel = payload => {
    deleteChannelMutation.mutate(payload);
  };

  return { deleteChannel, isDeleting: deleteChannelMutation.isLoading };
}
